module.exports = __webpack_public_path__ + "static/media/trust_img.dd10c7b7.png";